<template>
    <v-container fluid>
        <template v-if="!plan">
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>

        <v-card v-else class="mb-5 pa-2">
            <CardHeader
                :title="
                    $t('plans.form.texts.title-module', {
                        plan: plan.name,
                    })
                "
            />
            <v-row>
                <v-col>
                    <v-form ref="form" @submit.prevent="save">
                        <v-data-table :headers="headers" :items="plan.modules">
                            <template
                                #[getSlotName(`partner_price`)]="{ item }"
                            >
                                <v-currency-field
                                    v-bind="$t('money-config')"
                                    v-model="item.partner_price"
                                ></v-currency-field>
                            </template>
                            <template
                                #[getSlotName(`whitelabel_price`)]="{ item }"
                            >
                                <v-currency-field
                                    v-bind="$t('money-config')"
                                    v-model="item.whitelabel_price"
                                ></v-currency-field>
                            </template>
                            <template #[getSlotName(`action`)]="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            icon
                                            tile
                                            v-on="on"
                                            :to="{
                                                name: 'plans.module.edit',
                                                params: {
                                                    id: plan.id,
                                                    module: item.id,
                                                },
                                            }"
                                        >
                                            <v-icon color="blue-grey" v-on="on"
                                                >mdi-pencil</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('form.actions.edit') }}</span>
                                </v-tooltip>
                            </template>
                        </v-data-table>

                        <FormActions
                            :loadingSave="loading"
                            :showBackButton="false"
                        />
                    </v-form>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
import CardHeader from '@/components/utils/CardHeader'
import FormActions from '@/components/utils/FormActions'
import Plan from '@/models/plans/Plan'
import _ from 'lodash'

export default {
    props: ['id'],

    data: () => {
        return {
            plan: null,
            loading: false,
        }
    },

    components: {
        CardHeader,
        FormActions,
    },

    methods: {
        async getPlan() {
            let planModel = new Plan()
            let item = await planModel.find(this.id)
            this.plan = item
        },

        getSlotName(action) {
            return `item.${action}`
        },

        async save() {
            this.loading = true

            let data = this.getDataUpdated()

            let res = null
            try {
                res = await this.$http.put(
                    `config-plans/${this.plan.id}/module-batch`,
                    data,
                )
            } finally {
                this.loading = false
            }

            if (!res) return

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('plans.form.feedback.modules', {
                    name: this.plan.name,
                }),
            )

            this.getPlan()
        },

        getDataUpdated() {
            let data = { modules: [] }

            _.each(this.plan.modules, module => {
                data.modules.push({
                    id: module.id,
                    partner_price: module.partner_price,
                    whitelabel_price: module.whitelabel_price,
                })
            })

            return data
        },
    },

    computed: {
        headers() {
            return [
                {
                    text: this.$t('modules.index.table.headers.name'),
                    value: 'name',
                    sortable: false,
                },
                {
                    text: this.$t('modules.index.table.headers.partner-price'),
                    value: 'partner_price',
                    sortable: false,
                    width: 250,
                },
                {
                    text: this.$t(
                        'modules.index.table.headers.whitelabel-price',
                    ),
                    value: 'whitelabel_price',
                    sortable: false,
                    width: 250,
                },
                {
                    text: this.$t('tables.actions'),
                    value: 'action',
                    sortable: false,
                    width: 150,
                    align: 'end',
                },
            ]
        },
    },

    created() {
        this.getPlan()
    },
}
</script>
